import React from 'react';
import { format } from 'date-fns';
interface MoviePanelProps {
  company: [{
    companyName: string,
    movieName: string,
    url?: string,
    createDate: Date
  }],
}

const MoviePanel: React.FC<MoviePanelProps> = ({company}) => {
  return(
    <>
      <hr/>
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <table className="table">
              <thead className="thead-dark">
                <tr>
                  <th className="text-center" scope="col">NOME DO FILME</th>
                  <th  className="text-center" scope="col">DATA DO ENVIO</th>
                  <th  className="text-center" scope="col">VIDEO ENVIADO</th>
                </tr>
              </thead>
              <tbody>
                { company.map(comp => (
                  <tr>
                      <td>{comp.movieName}</td>
                      <td>{format(new Date(comp.createDate), 'dd/MM/yyyy HH:mm')}</td>
                      <td>{comp.url ? 'Sim' : 'Não'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default MoviePanel;
